export const getStyles = (_, { palette = {} }) => ({
  eventTypeContainer: {
    padding: '0px 20px',
    border: `1px solid ${palette.neutralLight}`,
    borderRadius: '2px',
    width: 'fit-content',
    height: '60px',
    display: 'flex',
    alignItems: 'center',
  },
  actionOperator: {
    marginRight: '8px',
    minWidth: '150px',
  },
  actionContainer: {
    display: 'flex',
    '& .url-input, .action-input': {
      flexGrow: 1,
      minWidth: 200,
      maxWidth: 360,
    },
    '& label': {
      padding: '7.6955px 0px',
    },
  },
  actionText: {
    marginTop: '5px',
    marginRight: '32px',
    fontWeight: 600,
  },
  actionTitle: {
    margin: '10.5px 0',
    lineHeight: '1.1',
    fontWeight: 600,
  },
  urlInput: {
    marginTop: '36.396px',
  },
  operatorDescription: {
    color: '#737271',
    marginTop: 8,
  },
  helpLink: {
    marginLeft: 4,
  },
});
